import React, {useState, useEffect, useReducer} from 'react';
import {State, Action, ToggleName, defaultReducer} from "./State";
import SignIn, {SignInFetchers} from "./SignIn";



function Header(props: { signIn: SignIn }) {

    return (
        <>
            { props.signIn.fetchers().sessionDestroy.renderErrors() }
            <div className="row my-3">
                <div className="md-12">
                    <a href={Constants.get("HOME_URL")}>Wang</a>
                    {" • "}
                    <a href={"/pages/new"}>Create Page</a>
                    { props.signIn.isSignedIn() &&
                        <>
                            {" • "}
                            {  props.signIn.currentUser()?.display_name }
                            {" • "}
                            <a href="#" onClick={() => {props.signIn.signOut()}}>Sign Out</a>
                        </>
                    }
                </div>
            </div>
        </>
    );
}

export default Header;
